import { cx } from "class-variance-authority";

import * as theme from "./SidebarCountBadge.css";

export interface SidebarCountBadgeProps {
    count?: number;
    className?: string;
}

export function SidebarCountBadge({
    count,
    className,
}: SidebarCountBadgeProps) {
    const isEmpty = count === undefined;

    return (
        <span
            data-slot="sidebar-count-badge"
            className={cx(theme.root, isEmpty && theme.empty, className)}
            aria-hidden={isEmpty}
        >
            {count}
        </span>
    );
}
